import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=71ae22e5&scoped=true"
import script from "./mobileFooter.vue?vue&type=script&lang=js"
export * from "./mobileFooter.vue?vue&type=script&lang=js"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&id=71ae22e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae22e5",
  null
  
)

export default component.exports